<script>
export default {
  name: 'AgeLabel',
  props: {
    birthdate: String,
  },
  data: function () {
    return {
      label: '- ปี',
    }
  },
  watch: {
    birthdate: function (val) {
      // Generate by ChatGPT
      const today = new Date()
      const birthDate = new Date(val)
      const ageInMonths =
        (today.getFullYear() - birthDate.getFullYear()) * 12 +
        today.getMonth() -
        birthDate.getMonth()
      const years = Math.floor(ageInMonths / 12)
      const months = ageInMonths % 12
      if (months > 0) {
        this.label = years + ' ปี ' + months + ' เดือน'
      } else {
        this.label = years + ' ปี'
      }
    },
  },
}
</script>

<template>
  <span class="h6 m-l m-t-xs text-primary">{{ label }}</span>
</template>
